/* AUTH TYPES */
export const SIMPLE_TYPE = 'unsecure';
export const DEMO_TYPE = 'demo';
export const PASSWORD_TYPE = 'password';
export const HOSTED_TYPE = 'enterprise-hosted';
